'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import type React from 'react';
import { createContext, useContext } from 'react';
import { cn } from '../../../shared/cn';
export enum DIALOG_VARIANTS {
  DEFAULT = 'default',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}
export type DialogVariant = `${DIALOG_VARIANTS}`;
const DialogVariantContext = createContext<DialogVariant>(DIALOG_VARIANTS.DEFAULT);
export const useDialogVariant = () => {
  return useContext(DialogVariantContext);
};
export type DialogPanelPlacement = 'center' | 'top';
export type DialogProps = Omit<Headless.DialogProps, 'className'> & {
  className?: string;
  type?: `${DIALOG_VARIANTS}`;
  /** Vertical placement of the panel. Defaults to centered viewport placement. */
  panelPlacement?: DialogPanelPlacement;
};
export const Dialog = t0 => {
  const $ = _c(26);
  let className;
  let props;
  let style;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      style,
      type: t1,
      panelPlacement: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = style;
    $[4] = t1;
    $[5] = t2;
  } else {
    className = $[1];
    props = $[2];
    style = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const type = t1 === undefined ? "default" : t1;
  const panelPlacement = t2 === undefined ? "center" : t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("fixed inset-0 z-50");
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Headless.DialogBackdrop className="fixed inset-0 backdrop-blur-xs transition-opacity" aria-hidden="true" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = panelPlacement === "top" ? "items-start pt-40" : "items-center";
  let t6;
  if ($[8] !== t5) {
    t6 = cn("flex min-h-full justify-center p-4 text-center", t5);
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== className) {
    t7 = cn("mx-auto w-full max-w-md overflow-hidden rounded-2xl bg-backgroundPrimary p-6 text-left align-middle shadow-xl transition-all", "border border-borderPrimary", className);
    $[10] = className;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== props.children || $[13] !== style || $[14] !== t7 || $[15] !== type) {
    t8 = <Headless.DialogPanel data-variant={type} className={t7} style={style}>{props.children}</Headless.DialogPanel>;
    $[12] = props.children;
    $[13] = style;
    $[14] = t7;
    $[15] = type;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="relative">{t4}<div className="fixed inset-0 overflow-y-auto"><div className={t6}>{t8}</div></div></div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== props || $[21] !== t9) {
    t10 = <Headless.Dialog as="div" {...props} className={t3}>{t9}</Headless.Dialog>;
    $[20] = props;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== type) {
    t11 = <DialogVariantContext.Provider value={type}>{t10}</DialogVariantContext.Provider>;
    $[23] = t10;
    $[24] = type;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};